import { apiSlice } from "../../app/api/apiSlice";

export const usersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: () => "/users",
      keepUnusedDataFor: 5,
    }),
    getUsersClean: builder.query({
      query: () => "/users/clean",
      keepUnusedDataFor: 5,
    }),
    getTrainerList: builder.query({
      query: () => "/users/trainer-list",
      keepUnusedDataFor: 30,
    }),
    createUser: builder.mutation({
      query: (data) => ({
        url: "/users",
        method: "POST",
        body: { ...data },
      }),
    }),
    updateUser: builder.mutation({
      query: (data) => ({
        url: "/users",
        method: "PATCH",
        body: { ...data },
      }),
    }),
    deleteUser: builder.mutation({
      query: (data) => ({
        url: "/users",
        method: "DELETE",
        body: { ...data },
      }),
    }),
    updateUserdataAsUser: builder.mutation({
      query: (data) => ({
        url: "/users/updateUserdataAsUser",
        method: "PATCH",
        body: { ...data },
      }),
    }),
    uploadProfileImage: builder.mutation({
      query: (formData) => ({
        url: "/users/profile-image",
        method: "POST",
        body: formData,
      }),
    }),
    firstLogin: builder.mutation({
      query: () => ({
        url: "/users/firstlogin",
        method: "POST",
      }),
    }),
    updatePassword: builder.mutation({
      query: (data) => ({
        url: "/users/changepassword",
        method: "PATCH",
        body: { ...data },
      }),
    }),
    updateMemberTableSettings: builder.mutation({
      query: (data) => ({
        url: "/users/changetablecolumns",
        method: "PATCH",
        body: { ...data },
      }),
    }),
    changeUsersPW: builder.mutation({
      query: (data) => ({
        url: "/users/changeUsersPW",
        method: "PATCH",
        body: { ...data },
      }),
    }),
    changeTenant: builder.mutation({
      query: (data) => ({
        url: "/users/change-tenant",
        method: "PATCH",
        body: { ...data },
      }),
    }),
    updateUserBanking: builder.mutation({
      query: (data) => ({
        url: "/users/banking",
        method: "POST",
        body: { ...data },
      }),
    }),
    updateActivity: builder.mutation({
      query: () => ({
        url: "/users/activity",
        method: "PATCH",
      }),
    }),
  }),
});

export const {
  useGetUsersQuery,
  useGetUsersCleanQuery,
  useGetTrainerListQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useUpdateUserdataAsUserMutation,
  useUploadProfileImageMutation,
  useFirstLoginMutation,
  useUpdatePasswordMutation,
  useChangeUsersPWMutation,
  useChangeTenantMutation,
  useUpdateUserBankingMutation,
  useUpdateMemberTableSettingsMutation,
  useUpdateActivityMutation,
} = usersApiSlice;
